import { render, staticRenderFns } from "./DisputeGridCard.vue?vue&type=template&id=7b97fd50"
import script from "./DisputeGridCard.vue?vue&type=script&lang=js"
export * from "./DisputeGridCard.vue?vue&type=script&lang=js"
import style0 from "./DisputeGridCard.vue?vue&type=style&index=0&id=7b97fd50&prod&lang=scss"
import style1 from "./DisputeGridCard.vue?vue&type=style&index=1&id=7b97fd50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports